import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { CustomerCreditTitle } from "../../../../Utils/Constants";
import axios from "axios";
import { baseUrl } from "../../../../Utils/FileUpload";
import { ApexOptions } from "apexcharts";
import { H2 } from "../../../../AbstractElements";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// Define the structure of the monthly credit data
interface MonthlyCredit {
  month: string;
  total_agent_amount: number | string;
  total_customer_amount: number | string;
  agent_credit: number;
  customer_credit: number;
}

export default function EarningCard({ colClass }: { colClass?: string }) {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const [totalCustomerCreditCurrentYear, setTotalCustomerCreditCurrentYear] =
    useState<number | null>(null);
  const [earningsData, setEarningsData] = useState<{
    series: { name: string; data: number[] }[];
    categories: string[];
  }>({
    series: [
      { name: "Agent Credit", data: [] },
      { name: "Customer Credit", data: [] },
    ],
    categories: [],
  });
  const [currency, setCurrency] = useState<string>("$");
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${baseUrl}call_history/get_monthly_credits`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        // console.log(response.data);
        const monthlyCredits: MonthlyCredit[] = response.data.monthly_credits;
        const agentCredits = monthlyCredits.map((item) => item.agent_credit);
        const customerCredits = monthlyCredits.map(
          (item) => item.customer_credit
        );
        const categories = monthlyCredits.map((item) => item.month);

        setEarningsData({
          series: [
            { name: "Agent Credit", data: agentCredits },
            { name: "Customer Credit", data: customerCredits },
          ],
          categories: categories,
        });

        setTotalCustomerCreditCurrentYear(
          response.data.total_customer_credit_current_year
        );
        setCurrency(response.data.currency || "$");
      } catch (error) {
        console.error("Failed to fetch card data:", error);
      } finally {
        setLoading(false); // Hide skeleton after data load
      }
    };

    fetchData();
  }, [token]);

  const earningsChart: ApexOptions = {
    series: earningsData.series,
    chart: {
      type: "bar",
      height: 505,
      offsetX: -20,
      offsetY: 10,
      toolbar: { show: false },
    },
    legend: { show: false },
    plotOptions: {
      bar: { horizontal: false, columnWidth: "75%", borderRadius: 2 },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 6, colors: ["transparent"] },
    grid: {
      show: true,
      borderColor: "#e5e5e5",
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    colors: ["#f39159", "#308e87"],
    xaxis: {
      categories: earningsData.categories,
      tickAmount: 4,
      tickPlacement: "between",
      labels: {
        style: {
          fontSize: "13px",
          fontFamily: "Nunito Sans', sans-serif",
          colors: "#AAA3A0",
          fontWeight: 600,
        },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        formatter: (val: number) => `${val}`,
        style: {
          fontSize: "13px",
          fontFamily: "Nunito Sans, sans-serif",
          colors: "#AAA3A0",
          fontWeight: 600,
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val.toLocaleString()}`,
      },
    },
    fill: { opacity: 1 },
    responsive: [
      {
        breakpoint: 1541,
        options: {
          chart: { height: 233 },
          plotOptions: { bar: { columnWidth: "80%" } },
          grid: { padding: { right: 0 } },
        },
      },
    ],
  };

  return (
    <Col className={colClass || "col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12"}>
      <Card className="earning-card">
        <CardHeader className="pb-0 card-no-border">
          <div className="header-top">
            <h3>{CustomerCreditTitle}</h3>
          </div>
        </CardHeader>
        <CardBody className="pb-0">
          {loading ? (
            <>
              <div
                className="d-flex align-center gap-3 "
                style={{ paddingBottom: "20px" }}
              >
                <Skeleton height={250} width={260} />
              </div>
            </>
          ) : (
            <>
              <div className="d-flex align-center gap-3">
                <H2>
                  {totalCustomerCreditCurrentYear !== null
                    ? `${totalCustomerCreditCurrentYear.toLocaleString()}`
                    : "N/A"}
                </H2>
              </div>
              <div id="earnings-chart">
                <ReactApexChart
                  type="bar"
                  options={earningsChart}
                  series={earningsData.series}
                  height={225}
                />
              </div>
            </>
          )}
        </CardBody>
      </Card>
    </Col>
  );
}

// import React from 'react'
// import { Card, CardBody, Col } from 'reactstrap'
// import ReactApexChart from 'react-apexcharts'
// import DropdownWithHeader from '../../../../Utils/CommonComponents/DropdownWithHeader'
// import { EarningsTrendTitle } from '../../../../Utils/Constants'
// import { earningsChart, monthlyDropdownList } from '../../../../Data/Dashboard/Default'
// import { H2 } from '../../../../AbstractElements'
// import DashboardSvgIcon from '../../../../Utils/CommonComponents/DashboardSvgIcon'

// export default function EarningCard() {
//     return (
//         <Col xxl={3} xl={4} sm={6} className="proorder-xxl-2 box-col-6">
//             <Card className="earning-card">
//                 <DropdownWithHeader end caret headerClass='pb-0 card-no-border' heading={EarningsTrendTitle} dropDownList={monthlyDropdownList} dropDownTitle='Monthly' />
//                 <CardBody className="pb-0">
// <div className="d-flex align-center gap-3">
//     <H2>{'$4,875'}</H2>
//     <span className="text-primary">
//         {'36.28% '}
//         <DashboardSvgIcon className="stroke-icon stroke-primary" iconId='arrow-down' />
//     </span>
// </div>
//                     <div id="earnings-chart">
//                         <ReactApexChart type="bar" options={earningsChart} series={earningsChart.series} height={225} />
//                     </div>
//                 </CardBody>
//             </Card>
//         </Col>
//     )
// }
